import { Injectable } from '@angular/core';
import { Modiwl } from '../../modelau/system/modiwl';
import { StorfaDefnyddiwrService } from '../system/storfa-defnyddiwr.service';


@Injectable({
  providedIn: 'root'
})
export class HawlModiwlService {

  constructor(private storfaDefnyddiwrService: StorfaDefnyddiwrService) { }

  gwirioHawl(modiwl: Modiwl): boolean {

    let proffil = this.storfaDefnyddiwrService.nolProffil();

    if (proffil && proffil.modiwlau) {
      let modiwlauString = proffil.modiwlau;

      modiwlauString = modiwlauString.replace('[', '').replace(']', '');

      let rhestrModiwlau = modiwlauString.split(',').map(Number) as Number[];

      if (rhestrModiwlau.includes(modiwl)) {
        return true;
      }
    }

    return false;
  }
}
